import React, { useEffect } from "react";
import { Field, reduxForm, initialize } from "redux-form";
import { required } from "redux-form-validators";
import { renderselect } from "../../../../../Components/Forms/renders";
import { useDispatch } from "react-redux";

const AddAmpereForm = ({ handleSubmit, ampere }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (ampere) {
      dispatch(initialize("addampere", { ampere }));
    }
  }, []);

  return (
    <form onSubmit={handleSubmit} className="kwh-settings p-2 mt-4">
      <h4 className="m-0">Ampere instellen</h4>

      <Field
        name="ampere"
        type="number"
        validate={[required()]}
        component={renderselect}
        label="Ampere instellen"
        options={{
          4: "4 Ampere",
          6: "6 Ampere",
          8: "8 Ampere",
          10: "10 Ampere",
          12: "12 Ampere",
          14: "14 Ampere",
          16: "16 Ampere",
          18: "18 Ampere",
          20: "20 Ampere",
        }}
      />

      <div className="box-footer">
        <button type="submit" className="btn btn-primary">
          Verzenden
        </button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: "addampere",
})(AddAmpereForm);
